// extracted by css-extract-rspack-plugin
export default {"tabs":"tabs-v_U4yd","count":"count-kmCfX1","segment":"segment-GoJAQm","chart":"chart-F3URCb","edit":"edit-ilaYJB","tab":"tab-IM8FsY","tabActive":"tabActive-BoCkAu"};